<template>
  <div class="scroller">
    <div class="list">
      <div class="list__heading">
        <h2>Navigations</h2>
        <router-link :to="{ name: 'navigations.create'}" class="btn btn--primary btn--small">New navigation</router-link>
      </div>

      <Loader v-if="isLoading" />
      <div class="listData" v-for="navigation in navigations.data" :key="navigation.id" v-else>
        <router-link :to="{ name: 'navigations.edit', params: { id: navigation.id }}" class="listData__link" @click="setSize()">
          <div class="listData__item">
            <h3 class="listData__heading mb0">{{ navigation.title }}</h3>
          </div>
        </router-link>
        <button class="listData__delete" @click="deleteNavigation(navigation)">
          <font-awesome-icon :icon="['fal', 'trash-alt']"/>
        </button>
      </div>
    </div>
    <Pagination :pagination="navigations.pagination" :Resource="navigation" :type="types.GET_ALL_NAVIGATIONS" :isLoading="types.IS_LOADING_NAVIGATIONS"/>
  </div>
</template>

<script>
import * as types from '@/store/types.js'
import Navigation from '@/model/Navigation'
import Loader from '@/components/Utils/Loader'
import Pagination from '@/components/Utils/Pagination'
import {loadResource, deleteResource} from '@/helpers/resource'

export default {
  computed: {
    navigations () {
      return this.$store.getters[types.ALL_NAVIGATIONS]
    },
    isLoading () {
      return this.$store.getters[types.IS_LOADING_NAVIGATIONS]
    },
    types () {
      return types
    },
    navigation () {
      return Navigation
    }
  },
  components: {
    Loader, Pagination
  },
  mounted () {
    loadResource(Navigation, types.GET_ALL_NAVIGATIONS, types.IS_LOADING_NAVIGATIONS)
  },
  methods: {
    deleteNavigation (navigation) {
      deleteResource(types.REMOVE_NAVIGATION, navigation)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation/NavigationList.vue